import React from 'react';
import { TextField } from 'formik-material-ui';
import { Field } from 'formik';

const CustomTextField = (props: any) => {
  const {
    field: { name },
    form: { errors, submitCount, touched },
  } = props;
  const getFieldValueFromName = (values: object) => name?.split('.').reduce((acc: any, key: any) => acc && acc[key], values);
  const errorMessage = errors && getFieldValueFromName(errors);
  const enableError = errorMessage && (getFieldValueFromName(touched) || (!!submitCount && !props.disabled));

  return (
    <TextField
      {...props}
      label={props.label}
      error={enableError}
      helperText={enableError ? errorMessage : props.helperText}
    />
  );
};

export default (props: any) => <Field {...props} variant="outlined" component={CustomTextField} />;
